import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-733b598d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-justify-center tw-items-center" }
const _hoisted_2 = { class: "tw-w-[2px]" }

import { getComponentUiText } from "@/utils/utilities";
import { ref, onMounted, onUnmounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'uploadLoadingButton',
  setup(__props) {

const loadingText = ref("");
const loadingStates = ["", ".", "..", "..."];
let index = 0;
let interval;

onMounted(() => {
  interval = setInterval(() => {
    loadingText.value = loadingStates[index];
    index = (index + 1) % loadingStates.length;
  }, 300);
});

onUnmounted(() => {
  clearInterval(interval);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", null, _toDisplayString(_unref(getComponentUiText)("app-settings-evidence-modal-uploading-1")), 1),
    _createElementVNode("span", _hoisted_2, _toDisplayString(loadingText.value), 1)
  ]))
}
}

})